/* eslint-disable @typescript-eslint/no-explicit-any */
import { EpkModuleApiService } from '~packages/epk-front-shared/api-client';
import { Mode, RequestMethod } from '~packages/json-api/client';

import getConstants from '@/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'IntegrApiService',
  mode: Mode.Production,
  needInit: isModeDevelopment,
};

export default class IntegrationsApiService extends EpkModuleApiService {
  constructor() {
    super(constructorParams);
    this.bigIntCb = (res: any) => {
      return res;
    };
  }

  async getFIASByAddress(address: string) {
    return await this._sendRequest(
      `/fias?like_addr=${address}`,
      null,
      { method: RequestMethod.GET },
      { method: 'getFIASByAddress' }
    );
  }

  async getFIASByStartAddress(address: string) {
    return await this._sendRequest(
      `/fias?start_addr=${address}`,
      null,
      { method: RequestMethod.GET },
      { method: 'getFIASByStartAddress' }
    );
  }

  async getEGRNByCadNumber(cadNumber: string) {
    return await this._sendRequest(
      `/egrn?cad_number=${cadNumber}`,
      null,
      { method: RequestMethod.GET },
      { method: 'getEGRNByCadNumber' }
    );
  }
}
